import axiosInstance from '../axiosConfig';

export interface Slide {
    id: number;
    title: string;
    image: string;
    image_url: string;
    full_description: string;
    button_text: string;
    button_link: string;
    button_route: string;
    impact_areas: string[];
    order: number;
    is_active: boolean;
    is_published: boolean;
    date?: string;
    author?: string;
    category?: string;
    created_at: string;
    updated_at: string;
}

export const slideService = {
    // Initialize CSRF token
    async initializeCsrf() {
        try {
            await axiosInstance.get('/sanctum/csrf-cookie');
            console.log('CSRF token initialized');
        } catch (error) {
            console.error('Failed to initialize CSRF token:', error);
        }
    },

    // Get all slides with pagination and search
    async getAll(params?: { page?: number; per_page?: number; search?: string }) {
        try {
            const response = await axiosInstance.get('/api/admin/slides', { params });
            return response.data;
        } catch (error) {
            console.error('Error in getAll:', error);
            throw error;
        }
    },

    // Get single slide by ID
    async getById(id: number) {
        try {
            const response = await axiosInstance.get(`/api/admin/slides/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in getById:', error);
            throw error;
        }
    },

    // Create new slide
    async create(formData: FormData) {
        try {
            const response = await axiosInstance.post('/api/admin/slides', formData);
            return response.data;
        } catch (error) {
            console.error('Error in create:', error);
            throw error;
        }
    },

    // Update slide
    async update(id: number, formData: FormData) {
        try {
            // For Laravel, add _method=PUT for FormData
            formData.append('_method', 'PUT');
            const response = await axiosInstance.post(`/api/admin/slides/${id}`, formData);
            return response.data;
        } catch (error) {
            console.error('Error in update:', error);
            throw error;
        }
    },

    // Delete slide
    async delete(id: number) {
        try {
            const response = await axiosInstance.delete(`/api/admin/slides/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in delete:', error);
            throw error;
        }
    },

    // Bulk delete slides
    async bulkDelete(ids: number[]) {
        try {
            const response = await axiosInstance.post('/api/admin/slides/bulk-delete', { ids });
            return response.data;
        } catch (error) {
            console.error('Error in bulkDelete:', error);
            throw error;
        }
    },

    // Update status
    async updateStatus(id: number, isActive: boolean) {
        try {
            const response = await axiosInstance.patch(`/api/admin/slides/${id}/status`, {
                is_active: isActive
            });
            return response.data;
        } catch (error) {
            console.error('Error in updateStatus:', error);
            throw error;
        }
    },

    // Update publish status
    async updatePublishStatus(id: number, isPublished: boolean) {
        try {
            const response = await axiosInstance.patch(`/api/admin/slides/${id}/publish`, {
                is_published: isPublished
            });
            return response.data;
        } catch (error) {
            console.error('Error in updatePublishStatus:', error);
            throw error;
        }
    },

    // Reorder slides
    async reorder(orders: { id: number; order: number }[]) {
        try {
            const response = await axiosInstance.post('/api/admin/slides/reorder', { orders });
            return response.data;
        } catch (error) {
            console.error('Error in reorder:', error);
            throw error;
        }
    }
};